export const removeDrafts = item => item.sys?.publishedVersion;
